import ImageRender from './ImageRender.vue'

export default ImageRender
